module.exports = __webpack_public_path__ + "img/radio-commercial.541de6d3.jpg";